import { get } from "lodash";
export default function ({ req, res, store, route, redirect }) {
  if (req && !get(req, "headers.cookie")) {
    console.log("cookie fix");
    req.headers.cookie = "";
  }
}
